var exports = {}

exports.postJSONData = function(url, payload, authToken){
    return exports.jsonRequestPromise(url, "POST", payload, authToken)
}

exports.getJSONData = function(url, authToken){
    return exports.jsonRequestPromise(url, "GET", undefined, authToken)
}

exports.jsonRequestPromise = function(url, method, payload, authToken){
    var fetchPromise = new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        if(authToken){
            if(!url.includes("?")) url += "?"
            url += "&jwt=" + authToken
        } 
        xhr.open(method, url, true);
        if(payload) payload = JSON.stringify(payload)
        xhr.send(payload);
        xhr.onerror = function () {
            reject([0, "Could not connect to server!"])
        }
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 401) { 
                    window.location = "/login?source=" + encodeURIComponent(window.location)
                }
                if (xhr.status === 403) { 
                    window.location = "/"
                }
                if (xhr.status === 302) { 
                    window.location = xhr.responseText
                }
                if (xhr.status === 200) {
                    //xhr finished successfully
                    var resp = xhr.responseText;
                    var respJson = JSON.parse(resp);
                    resolve(respJson);
                } else {
                    //xhr failed
                    reject([xhr.status, xhr.responseText]);
                }
            }
        }
    });
    return fetchPromise;
}


export default exports